module.exports = __webpack_public_path__ + "static/media/preloader-SMALL-PennyMac-Combined.f89e04d8.gif";